import request from './request';

// 获取对话列表
// "cursor": "",
// "pdUserAccount":"69593048@chnldx.com", // 查询具体用户的对话列表
// "limit": 20,
// "offset": 0
export const getDialogueList = (data) => {
  return request({
    url: '/chat/getPdHistoryChatBoxesList',
    method: 'post',
    data,
    headers: {
      isEncrypt: false,
    },
  });
};

// 获取表情
export const getSmilesList = (params) => {
  return request({
    url: '/mf/chat/smiles',
    method: 'get',
    params,
  });
};

// 对话备注列表
// 12312312321-12313123123
export const chatNoteList = (id) => {
  return request({
    url: `/auth/getPdUserRemarkInfo/${id}`,
    method: 'Post',
    headers: {
      isEncrypt: false,
    },
  });
};
// 删除备注列表
export const delChatNote = (id) => {
  return request({
    url: `/auth/delPdUserRemarkInfo/${id}`,
    method: 'post',
    headers: {
      isEncrypt: false,
    },
  });
};

// 查询个人信息
export const userDetail = (params) => {
  return request({
    url: '/mf/user/userDetail',
    method: 'get',
    params,
  });
};

// 获取贴纸列表
export const getStickersList = (params) => {
  return request({
    url: '/mf/chat/stickers',
    method: 'get',
    params,
  });
};

// 获取礼物列表
export const getCheersList = (params) => {
  return request({
    url: '/mf/chat/cheers',
    method: 'get',
    params,
  });
};

// /resource/oss/upload
// 上传文件
export const uploadFile = (data) => {
  return request({
    url: '/resource/oss/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
      isEncrypt: false,
    },
    data,
  });
};
// 多文件上传
export const uploadFiles = (data) => {
  return request({
    url: '/resource/oss/uploads',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
      isEncrypt: false,
    },
    data,
  });
};
// 获取我的列表
export const getMyList = () => {
  return request({
    url: '/auth/getPdUserProfiles',
    method: 'post',
    headers: {
      isEncrypt: false,
    },
  });
};

// 查询用户点赞、关注、邮件等统计
export const selectStatisticByUserAndDate = (data) => {
  return request({
    url: '/auth/selectStatisticByUserAndDate',
    method: 'post',
    data,
    headers: {
      isEncrypt: false,
    },
  });
};

// 获取邮件封面列表
export const getEmailCoverList = (params) => {
  return request({
    url: '/mf/chat/email/cover',
    method: 'get',
    params,
  });
};

// 新增备忘录
// {
//   "idUser":"abc-bca",
//   "remarkContent":"备注-备注"
// }
export const addChatNote = (data) => {
  return request({
    url: '/auth/addPdUserRemarkInfo',
    method: 'post',
    data,
    headers: {
      isEncrypt: false,
    },
  });
};

// 删除聊天信息
export const delChat = (data) => {
  return request({
    url: `/mf/chat`,
    method: 'delete',
    headers: {
      isEncrypt: false,
    },
    data,
  });
};
// 下载文件流
export const downloadFile = (ossId) => {
  return request({
    url: `/resource/oss/download/${ossId}`,
    method: 'get',
    responseType: 'blob', // 指定响应类型为blob
  });
};
// 获取未回复的聊天列表（分页）
export const getPdNoReplyChatBoxesPage = (data) => {
  return request({
    url: '/chat/getPdNoReplyChatBoxesPage',
    method: 'post',
    data,
    headers: {
      isEncrypt: false,
    },
  });
};
// 将未回复聊天删除
// /chat/delPdNoReplyChatBoxes/{id}
export const delPdNoReplyChatBoxes = (id) => {
  return request({
    url: `/chat/delPdNoReplyChatBoxes/${id}`,
    method: 'post',
    data: {
      id,
    },
    headers: {
      isEncrypt: false,
    },
  });
};
// 阅读通知消息
// /chat/readNoticeMessage
export const readNoticeMessage = (id) => {
  return request({
    url: '/chat/readNoticeMessage',
    method: 'post',
    data: {
      id,
    },
    headers: {
      isEncrypt: false,
    },
  });
};
